import { OrganizationKeyName } from "../../../../model/Organization";
import { AdminErrorListResponseData } from "../../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_USER_VOUCHER_FAIL = "SHOP:UPSERT_USER_VOUCHER_FAIL";

export const upsertUserVoucherFailAction = (
  organization: OrganizationKeyName,
  errors: AdminErrorListResponseData,
  id?: string
) => ({
  type: UPSERT_USER_VOUCHER_FAIL as typeof UPSERT_USER_VOUCHER_FAIL,
  organization,
  errors,
  id,
});

export type UpsertUserVoucherFailAction = ReturnType<
  typeof upsertUserVoucherFailAction
>;
